import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { ArrowRightIcon, Button, Loader, Tabs, Text } from "@sundae/ui-toolkit";
import { useWalletLoadingState, useWalletObserver } from "@sundaeswap/wallet-lite";
import { useNavigate } from "@tanstack/react-location";
import cx from "classnames";
import { lazy, useMemo, useState } from "react";
import ProposalNotFound from "../../components/ProposalNotFound";
import { EPATHS } from "../../constants/paths";
import { ProposalStatus } from "../../graphql/generated/proposals.sdk";
import { useBrandConfig } from "../../hooks";
import { usePermissions } from "../../hooks/usePermissions";
import { useQueryProposals } from "../../hooks/useQueryProposals";
import { Actions, useAppContext } from "../../stores";
const LazyProposalList = lazy(() => import("../../components/ProposalList"));
const Home = () => {
    const { t } = useI18N();
    const navigate = useNavigate();
    const { mainAddress, activeWallet } = useWalletObserver();
    const { ready } = useWalletLoadingState();
    const { dispatch } = useAppContext();
    const brand = useBrandConfig();
    const { data: { proposals: { proposals }, }, isLoading, } = useQueryProposals();
    const { canCreate } = usePermissions();
    const [currentTab, setCurrentTab] = useState("0");
    const isActive = ({ status, muted }) => !muted && (status === ProposalStatus.New || status === ProposalStatus.Ongoing);
    const isInactive = (p) => !isActive(p);
    const activeProposals = useMemo(() => proposals && proposals.filter(isActive), [proposals]);
    const otherProposals = useMemo(() => proposals && proposals.filter(isInactive), [proposals]);
    return (_jsx("div", { className: "text-center", children: isLoading ? (_jsx("div", { className: "flex items-center justify-center", children: _jsx(Loader, { size: "large" }) })) : (_jsxs(_Fragment, { children: [_jsxs(Text, { tag: "h4", size: "3xl", weight: "bold", className: "mb-8 flex flex-col items-center justify-between md:flex-row", children: [t("home.title"), canCreate && (_jsxs(Button, { size: "sm", variant: "secondary", className: cx("mt-2 font-sans md:mt-0", brand?.classes.buttons.all, brand?.classes.buttons.secondary), onClick: () => {
                                navigate({
                                    to: EPATHS.CREATE_PROPOSAL,
                                });
                            }, children: [t("actions.create", { ns: "createProposal" }), _jsx(ArrowRightIcon, {})] }))] }), _jsx(Tabs, { bg: "default", onValueChange: setCurrentTab, value: currentTab, primitiveProps: {
                        // @ts-ignore
                        trigger: {
                            className: cx("text-sm md:text-lg px-4", brand?.classes.buttons.tabs),
                        },
                    }, data: [
                        {
                            content: (_jsxs("div", { className: "p-8", children: [activeProposals?.length > 0 ? (_jsx(LazyProposalList, { proposals: activeProposals })) : (_jsx(ProposalNotFound, {})), _jsx(Button, { className: cx("mx-auto mt-8", brand?.classes.buttons.all, brand?.classes.buttons.colored), variant: "colored", onClick: () => {
                                            if (!activeWallet) {
                                                Actions.setConnectWalletOpen(true, dispatch);
                                                return;
                                            }
                                            navigate({
                                                to: EPATHS.CREATE_PROPOSAL,
                                            });
                                        }, children: !activeWallet
                                            ? t("wallet.button_connect_proceed")
                                            : t("actions.create", { ns: "createProposal" }) })] })),
                            id: "0",
                            trigger: t("home.ongoing"),
                        },
                        {
                            content: (_jsx("div", { className: "p-8", children: otherProposals?.length > 0 ? (_jsx(LazyProposalList, { proposals: otherProposals })) : (_jsx(ProposalNotFound, {})) })),
                            id: "1",
                            trigger: t("home.proposals"),
                        },
                    ] })] })) }));
};
export default Home;
//# sourceMappingURL=Home.js.map